import React, {useEffect, useReducer} from "react";
import {Alert, Container, Header} from "@amzn/awsui-components-react";
import {getLoadingSpinner} from "../../common/utils/commonUtils";
import {
    GET_QUICKSIGHT_EMBED_URL_INITIAL_STATE,
    getQuicksightEmbedUrlInitialState,
    getQuicksightEmbedUrlReducer
} from "../exception/components/redux/getQuicksightEmbedUrlReducer";
import {triggerGetQuickSightEmbedUrl} from "../exception/components/common/quicksightUtils";
import "../exception/css/errorSummary.css";

const CFS_DASHBOARD_ID = "4d491aef-b937-4c79-afd7-35de32f1ac90";
const CFS_DASHBOARD_SERVICE_NAME = "TASKLESS";

export default function CfsDashboardPage() {

    const [quicksightEmbedding, quicksightEmbeddingDispatcher] = useReducer(getQuicksightEmbedUrlReducer,
        GET_QUICKSIGHT_EMBED_URL_INITIAL_STATE, getQuicksightEmbedUrlInitialState);

    useEffect(() => {
        triggerGetQuickSightEmbedUrl(
            {
                dashboardId: CFS_DASHBOARD_ID,
                serviceName: CFS_DASHBOARD_SERVICE_NAME
            },
            undefined,
            quicksightEmbeddingDispatcher
        );
    }, []);

    return (
        <Container
            header={
                <Header variant="h2">
                    CFS Dashboard
                </Header>
            }
        >
            {
                quicksightEmbedding.failed ?
                    <Alert type="error">
                        Unable to load the dashboard. Please try again later.
                    </Alert>
                    : quicksightEmbedding.embedUrl ?
                        // sandbox restricts the cross-origin QuickSight frame (no top-navigation, no forms);
                        // allow-scripts/allow-same-origin are required for the embed to function,
                        // popups+downloads for QuickSight export/print.
                        <iframe title='QuickSight' className="dashboard"
                                sandbox="allow-scripts allow-same-origin allow-popups allow-downloads"
                                referrerPolicy="no-referrer"
                                src={quicksightEmbedding.embedUrl}/>
                        : getLoadingSpinner('ComponentSpinner')
            }
        </Container>
    );
}
